import React from 'react'
import axios from 'axios';
import { useHistory } from 'react-router-dom'
import { format } from 'date-fns'
import { Switch, Case, Default } from 'react-if'
import { Button} from 'reactstrap'
import { Empty } from 'antd';
import { FaCloudUploadAlt, FaRegEdit } from "react-icons/fa"
// import { FcTemplate,FcUpload } from "react-icons/fc";

import Pagination from "react-js-pagination"
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import ErrorSwal from '../../components/SwalError'
import LeaveDetail from '../../components/Modal/LeaveDetail'
import { LeaveLists, UploadDocument } from '../../components/functions/LeaveListPage';
import { FindOne } from '../../components/functions/LeaveRequestPage';


const pageSize = 5

const Index = () => {

    const { t } = useTranslation()
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const history = useHistory();
    const MySwal = withReactContent(Swal)
    const [leave, setLeave] = React.useState([])
    const [error, setError] = React.useState(null)
    const [isModalVisible, setIsModalVisible] = React.useState(false)
    const [isDesktopSize, setIsDeskTopSize] = React.useState(false)
    const [Approvals, setApprovals] = React.useState([])
    const [values, setValues] = React.useState({
        EmpNo: '',
        LeaveID: '',
        LeaveType: '',
        Reason: '',
        Status: '',
        Amount: '',
        Time: '',
        ToDate: '',
        EndDate: '',
        ToTime: '',
        EndTime: '',
        fileName: '',
        ApproveRemark: '',
        leaveTypes: [],
    })
    const cancelToken = React.useRef(null)


    // pagination
    const [page, setPage] = React.useState(1)
    const [total, setTotal] = React.useState(0)


    const getData = async (page) => {
        try {

            const resp = await LeaveLists(page, pageSize)
            setLeave(resp.data.PaginationLists.tutorials)
            setTotal(resp.data.PaginationLists.totalItems)

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }
    }
    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source();

        getData(page);

        return () => {

            cancelToken.current.cancel();
        };
    }, [page]);

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber)
    }

    const UploadFile = (e, Lid) => {
        const formData = new FormData();
        formData.append('file', e);
        formData.append('leaveNo', Lid)
        UploadDocument(formData)
            .then((response) => {
                ErrorSwal({
                    title: 'Success',
                    text: response.data.message,
                    icon: 'success'
                })
                history.go(0)
            })
            .catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })

    }
    const showModal = async (Leave) => {
        await FindOne(Leave.LEAVE_NO)
            .then((response) => {
                setApprovals(response.data.leave)
                setValues({
                    ...values,
                    EmpNo: response.data.leave.EMP_NO,
                    LeaveID: response.data.leave.LEAVE_NO,
                    LeaveType: response.data.leave.TYPECD,
                    Reason: response.data.leave.REASON,
                    Status: response.data.leave.STATUS,
                    Amount: response.data.leave.DAYS_QTY,
                    Time: response.data.leave.MIN_QTY,
                    ToDate: (format(new Date(response.data.leave.BEGIN_DT), 'dd/MM/yyyy')),
                    EndDate: (format(new Date(response.data.leave.END_DT), 'dd/MM/yyyy')),
                    ToTime: response.data.leave.BEGIN_TIME,
                    EndTime: response.data.leave.END_TIME,
                    fileName: response.data.leave.PATH_FILE,
                    ApproveRemark: response.data.leave.SIGN_REASON,
                    leaveTypes :  response.data.leave.leaveTypes
                })

            })
            .catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })

        setIsModalVisible(true);
        // ----------- resize screen -----------------
        if (window.innerWidth < 400) {
            setIsDeskTopSize(true)
        } else {
            setIsDeskTopSize(false)
        }
        // ----------- resize screen -----------------
    }


    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }


    return (
        <>

            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title"> {t("t_leave_list")} </h4>

                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    {leave.length > 0 ? (
                                        <table className="table mb-0 table-lg">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: '5%'  }}> {t("t_status")} </th>
                                                    <th scope="col" style={{ width: '15%' }}> {t("t_type")} </th>
                                                    <th scope="col" style={{ width: '30%' }}> {t("t_leave_day")}  </th>
                                                    <th scope="col" style={{ width: '15%' }}> {t("t_amount")} </th>
                                                    <th scope="col" style={{ width: '20%' }}> {t("t_reason")} </th>
                                                    {/* <th scope="col" style={{ width: '5%' }}>Request</th> */}
                                                    <th scope="col" style={{ width: '15%' }}> {t("t_action")} </th>
                                                    {/* <th scope="col" style={{ width: '5%' }}>File</th> */}

                                                </tr>
                                            </thead>
                                            <tbody style={{ fontSize: '0.9rem' }}>
                                                {
                                                    leave.map((list, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="text-bold-500">
                                                                    {
                                                                        <Switch>
                                                                            <Case condition={list.STATUS === "-3"}>
                                                                                <span className="badge bg-info" style={{ color: '#fff' }}>D</span>
                                                                            </Case>
                                                                            <Case condition={list.STATUS === "0"}>
                                                                                <span className="badge bg-warning" style={{ color: '#fff' }}>P</span>
                                                                            </Case>
                                                                            <Case condition={list.STATUS === "1"}>
                                                                                <span className="badge bg-success" style={{ color: '#fff' }}>A</span>
                                                                            </Case>
                                                                            <Case condition={list.STATUS === "-1"}>
                                                                                <span className="badge bg-danger" style={{ color: '#fff' }}>C</span>
                                                                            </Case>
                                                                            <Case condition={list.STATUS === "-2"}>
                                                                                <span className="badge bg-danger" style={{ color: '#fff' }}>R</span>
                                                                            </Case>
                                                                        </Switch>
                                                                    }
                                                                </td>
                                                                <td className="text-bold-500">
                                                                        <Switch>
                                                                            <Case condition={currentLanguageCode === 'en'}> {list.leaveTypes.TYPENM} </Case>
                                                                            <Case condition={currentLanguageCode === 'th'}> {list.leaveTypes.TYPENM2} </Case>
                                                                            <Case condition={currentLanguageCode === 'jp'}> {list.leaveTypes.TYPENM3} </Case>
                                                                            <Default> {list.leaveTypes.TYPENM} </Default>
                                                                        </Switch>
                                                                    
                                                                </td>
                                                                <td className="text-bold-500">
                                                                    {
                                                                        list.ALL_DAY_F === "1" ?
                                                                            `${format(new Date(list.BEGIN_DT), 'dd/MM/yyyy')} - ${format(new Date(list.END_DT), 'dd/MM/yyyy')}` : `${format(new Date(list.BEGIN_DT), 'dd/MM/yyyy')} ${list.BEGIN_TIME} - ${list.END_TIME}`
                                                                    }
                                                                </td>
                                                                <td className="text-bold-500">
                                                                    {
                                                                        list.ALL_DAY_F === "1" ? `${list.DAYS_QTY} day` : list.MIN_QTY
                                                                    }
                                                                </td>
                                                                <td className="text-bold-500">{list.REASON}</td>
                                                                {/* <td className="text-bold-500">{format(new Date(list.RGSTD), 'dd/MM/yyyy')}</td> */}
                                                                <td>
                                                                {/* <FcTemplate className='icon'  size={'2em'} onClick={async () => { showModal(list) }} />
                                                                <FcUpload className='icon'  size={'2em'} 
                                                                        onClick={async () => {
                                                                            const { value: file } = await MySwal.fire({
                                                                                title: `${t("t_upload_doc")}`,
                                                                                input: 'file',
                                                                                inputAttributes: {
                                                                                    'accept': '.jpeg,.jpg,.gif,.png,.pdf'
                                                                                },
                                                                                confirmButtonText: `${t("b_upload")}`,

                                                                            })
                                                                            if (file) {
                                                                                UploadFile(file, list.LEAVE_NO)
                                                                            } 
                                                                        }}
                                                                    /> */}

                                                                    <Button color="primary"
                                                                        onClick={async () => { showModal(list) }} >
                                                                        <FaRegEdit />
                                                                    </Button>
                                                                    {' '}
                                                                    <Button color="success"
                                                                        onClick={async () => {
                                                                            const { value: file } = await MySwal.fire({
                                                                                title: `${t("t_upload_doc")}`,
                                                                                input: 'file',
                                                                                inputAttributes: {
                                                                                    'accept': '.jpeg,.jpg,.gif,.png,.pdf'
                                                                                },
                                                                                confirmButtonText: `${t("b_upload")}`,

                                                                            })
                                                                            if (file) {
                                                                                UploadFile(file, list.LEAVE_NO)
                                                                            }
                                                                        }}
                                                                    >
                                                                        <FaCloudUploadAlt />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                    ) :
                                        <Empty />
                                    }
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <div className="mt-2">
                                    {leave.length > 0 ? (
                                        <Pagination
                                            activePage={page}
                                            itemsCountPerPage={pageSize}
                                            totalItemsCount={total}
                                            pageRangeDisplayed={5}
                                            onChange={handlePageChange}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            hideNavigation={true}
                                        />
                                    ) :
                                        <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Leave Details Modal */}
            {isModalVisible ? <LeaveDetail  isOpen={isModalVisible} isModalVisible={setIsModalVisible} values={values} Approvals={Approvals}  isDesktopSize={isDesktopSize} /> : null} 
            {/* Leave Details Modal */}

            
        </>
    )
}

export default Index
